import { type Collection } from '../collections'
import { type Content } from '../content'
import { type Tag } from '../tags'
import { TvShow } from '../tvshows'

export interface OVPBannerCarousel {
  id?: number
  title?: string
  type?: OVPCarouselType | null
  autoScroll?: boolean
  autoScrollInterval?: number
  items: Array<OVPBannerContent>
}

export interface OVPBannerParams {
  type: OVPBannerType
  sortOrder?: number
}

export type OVPBannerTypeContent = Content & OVPBannerParams
export type OVPBannerTypeTvShow = TvShow & OVPBannerParams
export type OVPBannerTypeTag = Tag & OVPBannerParams
export type OVPBannerTypeCollection = Collection & OVPBannerParams

export interface OVPBannerTypeLiveChannel extends OVPBannerParams {
  type: OVPBannerType.LIVE_CHANNEL
  id: number
  channelId: number
  title: string
  logo: string
  number: number
  banner: string
}

export type OVPBannerContent =
  | OVPBannerTypeContent
  | OVPBannerTypeTag
  | OVPBannerTypeCollection
  | OVPBannerTypeLiveChannel

export enum OVPBannerType {
  CONTENT = 'content',
  TVSHOW = 'tv_show',
  COLLECTIONS = 'collections',
  TAGS = 'tags',
  LIVE_CHANNEL = 'live_channel',
}

/** Carousel-level renderer hint, also returned as `carouselType` / `guestCarouselType` on home page settings */
export type OVPCarouselType = OVPBannerType.CONTENT | OVPBannerType.LIVE_CHANNEL
